import { PlayerRanking } from './PlayerRanking'

import { useArcadeMiniLeaderboardQuery } from '@/api/resources/arcade/rank/get/mini'

const SkeletonRanking = () => (
  <div className="h-4 bg-gray-800 animate-pulse rounded-[12px]"></div>
)

const Loading = () => (
  <div className="grid grid-cols-1 gap-[6px] w-full">
    <SkeletonRanking />
    <SkeletonRanking />
    <SkeletonRanking />
  </div>
)

export const SeasonRankings = () => {
  const { data: queryData } = useArcadeMiniLeaderboardQuery()

  if (!queryData?.data) return <Loading />

  const { leaderboard, season } = queryData.data

  return (
    <section className="grid grid-cols-[fit-content(100%)_auto_auto] items-center w-full">
      {leaderboard.map(playerRanking => (
        <PlayerRanking
          key={playerRanking.user_id}
          playerRanking={playerRanking}
          rankThreshold={season.rank_threshold}
        />
      ))}
    </section>
  )
}
